var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28207 0.814357C2.10927 0.628699 1.87944 0.527963 1.61723 0.528993C1.08462 0.531084 0.668427 0.964681 0.670589 1.51521C0.671654 1.78624 0.770979 2.03995 0.960173 2.22554L6.74335 8.01315L1.00581 13.846C0.818077 14.0331 0.720747 14.2876 0.721812 14.5586C0.72394 15.1007 1.14353 15.531 1.67614 15.5289C1.93834 15.5278 2.16741 15.4338 2.33875 15.2468L8.7047 8.76774C8.91692 8.55516 9.0306 8.29215 9.02947 8.00418C9.02834 7.71621 8.92082 7.46253 8.69872 7.24319L2.28207 0.814357Z",
    fill: "black",
    fillOpacity: 0.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.0d2c2fb152382e1bab9b7db5eadada43.svg";
export { ForwardRef as ReactComponent };